import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, UntypedFormGroup } from '@angular/forms';
import { operators } from '@app/library/models/criterias.model';
import { validCriterion } from '@app/shared/custom-validators';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { FormHelperService } from '@radioking/shared/common-services';
import { Observable, Subscription } from 'rxjs';

export const dateOrNumberOperators = [
  {
    id: operators.EQUALS,
    name: operators.EQUALS,
    translation: marker('PLAYLIST.CRITERIA.EQUALS'),
  },
  {
    id: operators.NOT_EQUALS,
    name: operators.NOT_EQUALS,
    translation: marker('PLAYLIST.CRITERIA.NOT_EQUALS'),
  },
  {
    id: operators.LOWER,
    name: operators.LOWER,
    translation: marker('PLAYLIST.CRITERIA.LOWER'),
  },
  {
    id: operators.LOWER_EQUALS,
    name: operators.LOWER_EQUALS,
    translation: marker('PLAYLIST.CRITERIA.LOWER_EQUALS'),
  },
  {
    id: operators.GREATER,
    name: operators.GREATER,
    translation: marker('PLAYLIST.CRITERIA.GREATER'),
  },
  {
    id: operators.GREATER_EQUALS,
    name: operators.GREATER_EQUALS,
    translation: marker('PLAYLIST.CRITERIA.GREATER_EQUALS'),
  },
  {
    id: operators.BETWEEN,
    name: operators.BETWEEN,
    translation: marker('PLAYLIST.CRITERIA.BETWEEN'),
  },
];

@Directive()
export abstract class PlaylistCriteriaDirective
  implements OnInit, OnDestroy, ControlValueAccessor
{
  // eslint-disable-next-line
  @Input('formControlName')
  index: number;

  @Input()
  submitEvent$: Observable<void>;

  @Input()
  title: string;

  @Output()
  readonly deleteCriteria = new EventEmitter<number>();

  criteriaForm: UntypedFormGroup;
  prevOperator: any;
  subscription = new Subscription();

  protected constructor(protected readonly formHelper: FormHelperService) {}

  ngOnInit() {
    this.subscription.add(this.submitEvent$.subscribe(() => this.checkForm()));
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkForm() {
    this.criteriaForm.setValidators(validCriterion());
    this.formHelper.forceValidationTrigger(this.criteriaForm);
  }

  isEqualsOperator() {
    return (
      this.criteriaForm.get('operator').value.name === operators.EQUALS ||
      this.criteriaForm.get('operator').value.name === operators.NOT_EQUALS
    );
  }

  abstract registerOnChange(fn: any): void;

  registerOnTouched(_: any): void {}

  setDisabledState(_: boolean): void {}

  abstract writeValue(obj: any): void;
}
